import { Link } from '@fly/core';
import { InsightItem } from '@fly/shared-ui';
import { FlySvgSprite } from '@fly/svg';

export function RepositoryInsightItem({
  isLoading,
  repository,
  href,
}: {
  isLoading: boolean;
  repository: string;
  href: string;
}) {
  return (
    <InsightItem
      inset
      loading={isLoading}
      content={
        <Link
          href={href}
          target='_blank'
          rel='noopener noreferrer'
          className='group min-h-8 flex items-start justify-between gap-fly-3 px-fly-4'
        >
          <div className='flex items-start gap-fly-3 text-custom-12'>
            <div className='h-5 flex flex-shrink-0 items-center'>
              <FlySvgSprite name='github' className='flex-shrink-0' size={16} />
            </div>
            <span className='text-indigoA-9 text-size-fly-2'>{repository}</span>
          </div>
          <div className='h-5 flex flex-shrink-0 items-center'>
            <FlySvgSprite
              name='external_link'
              size={16}
              className='flex-shrink-0 text-custom-12 opacity-0 group-hover:opacity-100'
            />
          </div>
        </Link>
      }
    />
  );
}
